import { Validator, errorMessages, constants } from 'services/validator'
import { INPUT_ERROR_PLACEHOLDER } from 'constant'
import {
  OLD_PASSWORD_PROPERTY,
  NEW_PASSWORD_PROPERTY,
  NEW_PASSWORD_CONFIRMATION_PROPERTY
} from './constants'

export default Validator.combineValidators({
  [OLD_PASSWORD_PROPERTY]: {
    errorMessage: errorMessages.PASSWORD_EMPTY,
    validators: Validator.required()
  },
  [NEW_PASSWORD_PROPERTY]: [
    {
      errorMessage: errorMessages.PASSWORD_EMPTY,
      validators: Validator.required()
    },
    {
      errorMessage: INPUT_ERROR_PLACEHOLDER,
      validators: [
        Validator.length(constants.PASSWORD_MIN_LENGTH),
        Validator.containUpperLowerCaseLetter(),
        Validator.containNumber(),
        Validator.containSpecialCharacter(),
        Validator.match(NEW_PASSWORD_CONFIRMATION_PROPERTY)
      ]
    }
  ],
  [NEW_PASSWORD_CONFIRMATION_PROPERTY]: {
    errorMessage: errorMessages.PASSWORD_EMPTY,
    validators: Validator.required()
  }
})
